export class DummyProvider {    
    login = (_language) => {};

    signup = () => {};

    silentAuthentication = (_callback) => {};

    otcAuthentication = (_code, _userName) => {};

    passUserName = (_userName) => {};

    handleAuthentication = (_callback) => {};

    logout = () => {};

    getAccessToken = () => {};

    getProfile = () => { return {}; };

    getTokenTimeToLive = () => {};

    isAuthenticated = () => false;

    redirect = (_app, _route) => {};
}